import Arrow from "../LogoSVG/Arrow";

function ConnectDesktopItem({
  hoveredIndex,
  setHoveredIndex,
  Logo,
  url,
  index,
  nameLogo,
  className
}: any) {
  return (
    <div
      className={`flex flex-start items-center ${
        hoveredIndex == undefined || hoveredIndex == index ? "" : "opacity-55"
      }`}
      onMouseEnter={() => setHoveredIndex(index)}
      onMouseLeave={() => setHoveredIndex(undefined)}
    >
      <a
        className={`w-[240px] bg-gray-2 hover:scale-[1.05] transition-all duration-200
         flex flex-row items-center mr-3 p-4 rounded-lg justify-between ${className}`}
        href={url}
        target="_blank"
      >
        <div className="flex flex-row items-center">
          <Logo />
          <p className="ml-4 text-[17px] leading-7">{nameLogo}</p>
        </div>
        <Arrow />
      </a>
    </div>
  );
}

export default ConnectDesktopItem;
